import React from 'react';
import useWindowSize from '../utils/use_window_size';

const Restart = ({ score, childCard, startImg, restartGame }) => {
  const windowSize = useWindowSize();
  return (
    <div className="relative">
      {
        childCard != null ?
          <div className="flex w-full max-w-6xl m-auto px-4 sm:px-16 mt-8 sm:mt-8 md:mt-12 lg:mt-24 mb-8">
            <div className="w-full sm:w-1/2 mx-auto relative cursor-pointer rounded-lg" style={{boxShadow: '0 4px 0 0 rgba(5, 21, 34, .29)' }} onClick={restartGame}>
              <div style={{ paddingBottom: '56.25%' }}>
                <div className="absolute inset-x-0 top-0 w-full z-10 mt-4">
                  <div
                    style={{ textAlign: 'center', color: '#10B981', backgroundColor: 'rgba(255,255,255,.8)' }}
                    className="w-48 mx-auto rounded"
                  >
                    {`jouw score: ${score}`}
                  </div>
                </div>
                <img src={childCard.image} alt={'Speel opnieuw'} className="absolute inset-0 w-full h-full object-cover rounded-lg" />
                <img src={startImg} alt={'Herstart knop'} className="absolute inset-x-0 bottom-0 w-1/3 mx-auto mb-4" style={{ opacity: '.9' }} />
              </div>
            </div>
          </div>
        : <div
            className="w-full max-h-screen flex flex-col items-center justify-around"
            style={{ height: `${windowSize.height}px` }}
          >
            <div
              className="w-48 rounded"
              style={{ textAlign: 'center', color: '#10B981', backgroundColor: 'rgba(255,255,255,.8)' }}
            >
              {`jouw score: ${score}`}
            </div>
            <img src={startImg} alt={'Herstart knop'} className="w-48 h-48" onClick={restartGame}/>
          </div>
      }
    </div>
  )
};

export default Restart;
